module.exports = __webpack_public_path__ + "img/skill-2.c190233a.png";